// src/Footer.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import useScrollToTop from './hooks/useScrollToTop';

const Footer = () => {
  useScrollToTop(); // Use the custom hook

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://simplyigbo-backend.onrender.com/api/subscribe', { email });
      if (response.status === 200 || response.status === 201) {
        setMessage('Subscribed to newsletter successfully');
      }
    } catch (err) {
      console.error('Failed to subscribe to newsletter:', err);
      setMessage('Failed to subscribe to newsletter');
    }
  };

  const footerStyle = {
    padding: '2rem 0',
    backgroundColor: '#1a1a1a', // Dark gray
    color: 'white',
  };

  const containerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    maxWidth: '1200px',
    margin: '0 auto',
    alignItems: 'flex-start',
  };

  const sectionStyle = {
    flex: '1',
    minWidth: '200px',
    marginBottom: '1rem',
    textAlign: 'left',
    padding: '0 1rem',
  };

  const titleStyle = {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
  };

  const paragraphStyle = {
    fontSize: '1rem',
    marginBottom: '1.5rem',
  };

  const listStyle = {
    listStyle: 'none',
    padding: '0',
  };

  const listItemStyle = {
    marginBottom: '0.5rem',
  };

  const linkStyle = {
    textDecoration: 'none',
    color: 'white',
    transition: 'color 0.3s',
  };

  const socialIconStyle = {
    width: '24px',
    height: '24px',
    marginRight: '0.75rem',
    transition: 'color 0.3s',
  };

  const formContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  };

  const inputStyle = {
    padding: '0.75rem',
    borderRadius: '0.375rem 0 0 0.375rem', // Rounded corners for the left side only
    border: '1px solid #ddd',
    textAlign: 'center',
    width: '100%',
    maxWidth: '400px', // Make the input longer
    marginRight: '0', // Remove the right margin
  };

  const buttonStyle = {
    backgroundColor: '#ff7c0a',
    color: 'white',
    padding: '0.85rem 0.8rem',
    borderRadius: '0 0.375rem 0.375rem 0', // Rounded corners for the right side only
    border: 'none',
    fontSize: '0.8rem',
    cursor: 'pointer',
  };

  const copyrightStyle = {
    marginTop: '2rem',
    textAlign: 'center',
    fontSize: '1rem',
  };

  return (
    <footer style={footerStyle}>
      <div style={containerStyle}>
        {/* About Section */}
        <div style={sectionStyle}>
          <h3 style={titleStyle}>Simply<span style={{ color: '#ff7c0a' }}>Igbo</span></h3>
          <p style={paragraphStyle}>
            Simply<span style={{ color: '#ff7c0a' }}>Igbo</span> is an online platform dedicated to teaching the
            Igbo language. Join our community and start your learning journey today!
          </p>
        </div>

        {/* Navigation Links */}
        <div style={sectionStyle}>
          <h3 style={titleStyle}>Quick Links</h3>
          <ul style={listStyle}>
            <li style={listItemStyle}><Link to="/" style={linkStyle} onMouseOver={e => e.target.style.color = '#ff7c0a'} onMouseOut={e => e.target.style.color = 'white'}>Home</Link></li>
            <li style={listItemStyle}><Link to="/about" style={linkStyle} onMouseOver={e => e.target.style.color = '#ff7c0a'} onMouseOut={e => e.target.style.color = 'white'}>About</Link></li>
            <li style={listItemStyle}><Link to="/blog" style={linkStyle} onMouseOver={e => e.target.style.color = '#ff7c0a'} onMouseOut={e => e.target.style.color = 'white'}>Blog</Link></li>
            <li style={listItemStyle}><Link to="/contact" style={linkStyle} onMouseOver={e => e.target.style.color = '#ff7c0a'} onMouseOut={e => e.target.style.color = 'white'}>Contact</Link></li>
            <li style={listItemStyle}><Link to="/login" style={linkStyle} onMouseOver={e => e.target.style.color = '#ff7c0a'} onMouseOut={e => e.target.style.color = 'white'}>Login</Link></li>
          </ul>
        </div>

        {/* Contact Information */}
        <div style={sectionStyle}>
          <h3 style={titleStyle}>Contact Us</h3>
          <p>Email: info@simplyigbo.com</p>
          <p>Phone: +123 456 7890</p>
          <div style={{ display: 'flex', marginTop: '1rem' }}>
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" style={linkStyle} onMouseOver={e => e.target.style.color = '#ff7c0a'} onMouseOut={e => e.target.style.color = 'white'}>
              <img src={`${process.env.PUBLIC_URL}/images/🦆 icon _facebook icon_.svg`} alt="Facebook" style={socialIconStyle} />
            </a>
            <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" style={linkStyle} onMouseOver={e => e.target.style.color = '#ff7c0a'} onMouseOut={e => e.target.style.color = 'white'}>
              <img src={`${process.env.PUBLIC_URL}/images/🦆 icon _XRP Cryptocurrency_.svg`} alt="Twitter" style={socialIconStyle} />
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" style={linkStyle} onMouseOver={e => e.target.style.color = '#ff7c0a'} onMouseOut={e => e.target.style.color = 'white'}>
              <img src={`${process.env.PUBLIC_URL}/images/🦆 icon _instagram icon_.svg`} alt="Instagram" style={socialIconStyle} />
            </a>
            <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" style={linkStyle} onMouseOver={e => e.target.style.color = '#ff7c0a'} onMouseOut={e => e.target.style.color = 'white'}>
              <img src={`${process.env.PUBLIC_URL}/images/🦆 icon _linkedin original_.svg`} alt="LinkedIn" style={socialIconStyle} />
            </a>
          </div>
        </div>

        {/* Newsletter Section */}
        <div style={sectionStyle}>
          <h3 style={titleStyle}>Newsletter</h3>
          <p style={paragraphStyle}>Subscribe to our newsletter to get the latest updates and offers.</p>
          <form onSubmit={handleSubscribe} style={formContainerStyle}>
            <input
              type="email"
              name="email"
              placeholder="Your email"
              value={email}
              onChange={handleEmailChange}
              style={inputStyle}
              required
            />
            <button type="submit" style={buttonStyle}>Subscribe</button>
          </form>
          {message && <p>{message}</p>}
        </div>
      </div>

      {/* Copyright Section */}
      <div style={copyrightStyle}>
        <p>&copy; 2024 Simply<span style={{ color: '#ff7c0a' }}>Igbo</span>. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;